<script lang="ts">
  import type { FieldState, Option } from '@shared/types';
  import { is } from '@shared/utils';

  export let options: Option[];
  export let activeIndex: number = -1; // control elements by index id; set initial position
  export let value: string | number = options[activeIndex]?.value; // control elements by value
  export let state: FieldState = 'default';
  export let name: string | undefined = undefined;

  let buttons: HTMLLabelElement[] = [];
  const names = options.map((i) => i.value);

  $: activeIndex = names.indexOf(value);
</script>

<div class="bg-default-100 dark:bg-dark-50 w-fit rounded-full px-1 py-1">
  <div class="relative flex w-fit overflow-hidden">
    <div
      class="background bg-default-50 dark:bg-dark-400 absolute inset-0 h-full w-full -translate-x-full rounded-full px-2 py-1 duration-300"
    ></div>
    {#each options as option, index}
      <label
        class="relative inline-block cursor-pointer rounded-full px-5 py-2 text-base {is(
          option.value === value,
          'text-default-900 bg-default-50 dark:bg-dark-500 dark:text-white',
          'text-default-700 dark:text-dark-800',
        )} hover:text-default-900 dark:hover:text-white"
        bind:this="{buttons[index]}"
      >
        {option.text}
        <input
          {name}
          type="radio"
          class="hidden"
          bind:group="{value}"
          value="{option.value}"
          disabled="{state === 'disabled'}"
        />
      </label>
    {/each}
  </div>
</div>
